import { NeoNamespace } from '../common-enum';

export class NeoError extends Error {
  static isNeoError(error: any) {
    return error?.name === 'NeoError';
  }
  name: string = 'NeoError';

  // 模块命名空间
  namespace: NeoNamespace = NeoNamespace.Undefined;

  // 错误类型
  type: string = '';

  constructor(namespace: NeoNamespace, message: string, type: string = '') {
    super(`${namespace && `${namespace} - `}${message}`);

    this.namespace = namespace;
    this.type = type;
  }

  toString() {
    const { name, namespace, message } = this;

    return `${name}: ${namespace && `${namespace} - `}${message}`;
  }
}

export default NeoError;
